import { Component, inject, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogTitle, MatDialogClose } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'
import { TranslateModule } from '@ngx-translate/core'
import { firstValueFrom } from 'rxjs'

export type PdfPreviewDialogData = {
  downloadUrl: string
  fileName: string
}

@Component({
  selector: 'app-pdf-preview-dialog',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogClose,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    NgxExtendedPdfViewerModule,
    TranslateModule,
  ],
  templateUrl: './pdf-preview-dialog.component.html',
  styleUrls: ['./pdf-preview-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfPreviewDialogComponent implements OnInit {
  data: PdfPreviewDialogData = inject(MAT_DIALOG_DATA)
  dialogRef = inject(MatDialogRef<PdfPreviewDialogComponent>)
  http = inject(HttpClient)
  changeDetectorRef = inject(ChangeDetectorRef)

  pdfBlob: Blob | null = null
  isLoading = true
  hasError = false

  ngOnInit(): void {
    this.loadPdf()
  }

  private async loadPdf(): Promise<void> {
    if (this.data.downloadUrl === null || this.data.downloadUrl === undefined) {
      console.error('PDF download URL is not available')
      this.hasError = true
      this.isLoading = false
      this.changeDetectorRef.markForCheck()
      return
    }
    try {
      this.pdfBlob = await firstValueFrom(this.http.get(this.data.downloadUrl, { responseType: 'blob' }))
    } catch (error) {
      console.error('Failed to load PDF:', error)
      this.hasError = true
    } finally {
      this.isLoading = false
      this.changeDetectorRef.markForCheck()
    }
  }

  close(): void {
    this.dialogRef.close()
  }
}
